import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

import { TwtOrderType } from '~/tenants/twt/model/enums';

export default createPerformableConfig(
  'video',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      voiceover: coerceBoolean().optional(),
      raw: coerceBoolean().optional(),
      virtual: coerceBoolean().optional(),
    }),
  },
  {
    name: 'Cinematic Property Video',
    short: 'A fully edited cinematic horizontal video shot from both the ground and with a drone highlighting the interior of a property as well as its exterior and the immediate surrounding area.',
    tenant: TenantId.TWIST_TOURS,
    color: '#819836',
    thumbnail(metadata: Record<string, unknown>) {
      if ('type' in metadata && metadata.type === TwtOrderType.COMMERCIAL) {
        return 'tenant/twt/video/commercial.png';
      }

      return 'tenant/twt/video/thumbnail.png';
    },
    images: [],
  },
);
